import todosLosOrigenes from "./origenes.json"
import { aeropuertosDestino } from "./destinos"

// Orígenes que se muestran directo en el select de cotizaciones.
export const origenesPrincipales = [
  { value: "BOG", label: "Bogotá" },
  { value: "CLO", label: "Cali" },
  { value: "MDE", label: "Medellín" },
  { value: "CTG", label: "Cartagena" },
  { value: "BAQ", label: "Barranquilla" },
  { value: "BGA", label: "Bucaramanga" },
  { value: "LET", label: "Leticia" },
  { value: "AXM", label: "Armenia" },
  { value: "PEI", label: "Pereira" },
  { value: "PSO", label: "Pasto" },
  { value: "PPN", label: "Popayán" },
  { value: "SMR", label: "Santa Marta" },
  { value: "MTR", label: "Montería" },
  { value: "RCH", label: "Riohacha" },
  { value: "VVC", label: "Villavicencio" },
  { value: "IBE", label: "Ibagué" },
  { value: "NVA", label: "Neiva" },
  { value: "CUC", label: "Cúcuta" },
  { value: "MZL", label: "Manizales" },
  { value: "VUP", label: "Valledupar" },
  { value: "EYP", label: "Yopal" }
]

// Valor del select que abre el input de "otro origen".
export const ORIGEN_OTROS = "OTROS"

const codigosPrincipales = new Set(origenesPrincipales.map(o => o.value))

export function esOrigenPrincipal(codigo) {
  return codigosPrincipales.has(codigo)
}

// Orígenes del JSON que no están en la lista principal, listos para v-select.
export const origenesOtros = todosLosOrigenes
  .filter(o => !codigosPrincipales.has(o.iata))
  .map(o => ({
    value: o.iata,
    label: `${o.ciudad} (${o.iata}) - ${o.pais}`
  }))

/** Aeropuertos a los que vuela un destino; si no está mapeado, el propio código. */
export function aeropuertosDe(destino) {
  if (!destino) return []
  return aeropuertosDestino[destino] || [destino]
}

/** true si el origen cae en alguno de los aeropuertos del destino. */
export function origenCoincideConDestino(origen, destino) {
  if (!origen || !destino) return false
  const codigo = origen.toUpperCase()
  return codigo === destino.toUpperCase() || aeropuertosDe(destino).includes(codigo)
}

/** Nombre legible de un código de origen (principal u "otro"). */
export function nombreOrigen(codigo) {
  const principal = origenesPrincipales.find(o => o.value === codigo)
  if (principal) return principal.label
  return todosLosOrigenes.find(o => o.iata === codigo)?.ciudad || codigo
}
